import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IconComponent } from '@design-system/buttons/icon/icon.component';
import { AnchorComponent } from '@design-system/buttons/anchor/anchor.component';
@Component({
  selector: 'app-custom-snack-bar',
  templateUrl: 'custom-snack-bar.component.html',
  styleUrls: ['custom-snack-bar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    AnchorComponent
  ]
})
export class CustomSnackBarComponent {
  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) {}
}
